'use client'

import { useEffect } from 'react'

import {
  getStorage,
  removeStorage,
  STORAGE_KEY,
  useDialog,
  useSession,
} from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'

const DIALOG = {
  BLOCKED_USER: 'BLOCKED_USER',
} as const

type MainDialog = keyof typeof DIALOG

export const BlockedUserDialog = () => {
  const session = useSession()
  const { isOpen, open, closeHandler } = useDialog<MainDialog>()

  useEffect(() => {
    const isBlockedUser = session.data?.blocked
    const showBlockedUserDialog =
      getStorage(STORAGE_KEY.SHOW_BLOCKED_USER_DIALOG) === 'true'

    if (showBlockedUserDialog && isBlockedUser) {
      open(DIALOG.BLOCKED_USER)
    }

    removeStorage(STORAGE_KEY.SHOW_BLOCKED_USER_DIALOG)
  }, [])

  return (
    <AlertDialog
      isOpen={isOpen(DIALOG.BLOCKED_USER)}
      onOpenChange={closeHandler(DIALOG.BLOCKED_USER)}
      title="규정 위반으로 이용이 중지되었습니다"
      content={`고객센터 33m2@spacev.kr 로\n문의주시기 바랍니다.`}
    />
  )
}
